import { c as _c } from "react/compiler-runtime";
import { Button } from '@udemy-v2/react-core-components';
import React, { useMemo, useSyncExternalStore } from 'react';
import { useI18n } from '@udemy-v2/i18n';
import { reportAbuseLink } from './urls';
// import getConfigData from 'utils/get-config-data';

import styles from './report-abuse.module.scss';
import { useCommonData } from '@udemy-v2/common-data';
export interface ReportAbuseProps {
  className?: string;
  fullWidthButton?: boolean;
  objectId: number;
  objectType: string;
  size?: 'medium' | 'large';
  text?: string;
  udStyle?: 'secondary' | 'ghost';
  onClick?: () => void;
  withDivider?: boolean;
}
export const ReportAbuse: React.FC<ReportAbuseProps> = t0 => {
  const $ = _c(21);
  const {
    className: t1,
    fullWidthButton: t2,
    objectId,
    objectType,
    size: t3,
    text: textProp,
    udStyle: t4,
    onClick: t5,
    withDivider: t6
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const fullWidthButton = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "medium" : t3;
  const udStyle = t4 === undefined ? "ghost" : t4;
  const onClick = t5 === undefined ? _temp : t5;
  const withDivider = t6 === undefined ? false : t6;
  const {
    gettext,
    locale
  } = useI18n();
  let t7;
  if ($[0] !== gettext || $[1] !== textProp) {
    t7 = textProp ?? gettext("Report abuse");
    $[0] = gettext;
    $[1] = textProp;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const text = t7;
  const {
    user
  } = useCommonData();
  const returnUrl = useSyncExternalStore(_temp3, _temp4, _temp5);
  let t8;
  if ($[3] !== locale || $[4] !== objectId || $[5] !== objectType || $[6] !== returnUrl || $[7] !== user) {
    bb0: {
      const reportAbuseFormFullUrl = reportAbuseLink({
        objectId,
        objectType,
        extraParams: {
          source: "course_landing_page",
          return_link: returnUrl
        }
      });
      if (user) {
        t8 = reportAbuseFormFullUrl;
        break bb0;
      }
      const nextParamValue = reportAbuseFormFullUrl;
      const authUrlSearchParams = new URLSearchParams();
      authUrlSearchParams.append("locale", locale || "en_US");
      authUrlSearchParams.append("next", nextParamValue);
      authUrlSearchParams.append("response_type", "json");
      authUrlSearchParams.append("action", "login");
      authUrlSearchParams.append("mode", "");
      t8 = `${"/join/passwordless-auth/"}?${authUrlSearchParams.toString()}`;
    }
    $[3] = locale;
    $[4] = objectId;
    $[5] = objectType;
    $[6] = returnUrl;
    $[7] = user;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const url = t8;
  let t9;
  if ($[9] !== className || $[10] !== onClick || $[11] !== size || $[12] !== text || $[13] !== udStyle || $[14] !== url) {
    t9 = <Button className={className} componentClass="a" href={url} size={size} udStyle={udStyle} onClick={onClick} data-purpose="report-abuse-link">{text}</Button>;
    $[9] = className;
    $[10] = onClick;
    $[11] = size;
    $[12] = text;
    $[13] = udStyle;
    $[14] = url;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const button = t9;
  if (fullWidthButton) {
    const t10 = `${styles.componentMargin} ${styles.componentBorder} ${withDivider ? styles.divider : ""}`;
    let t11;
    if ($[16] !== button) {
      t11 = <div className={styles["report-abuse-full-width"]}>{button}</div>;
      $[16] = button;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    let t12;
    if ($[18] !== t10 || $[19] !== t11) {
      t12 = <div className={t10}>{t11}</div>;
      $[18] = t10;
      $[19] = t11;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    return t12;
  }
  return button;
};
function _temp() {}
function _temp2() {}
function _temp3() {
  return _temp2;
}
function _temp4() {
  return window.location.href;
}
function _temp5() {
  return "/";
}